<!--
 * @Descripttion: 
 * @Author: voanit
 * @Date: 2020-03-19 20:27:26
 * @LastEditors: voanit
 * @LastEditTime: 2021-01-13 19:12:15
-->
<template>
  <div id="app">
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>
<script>
export default {
  name: 'App',
  beforeDestroy() {}
}
</script>
